var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section hero"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h2',{staticClass:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("\n                    "+_vm._s(_vm.caption)+"\n                ")])])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f62c97b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/common/HeaderSection.vue
// module id = FTvq
// module chunks = 1